import styled from 'styled-components';
import { AXSNotification } from '@axs/axsui-components';

export const AXSNotificationStyled = styled(AXSNotification)<any>`
  background-color: #da171a;
  min-height: 24px;
  padding: 15px 50px 15px 10px;
  margin-bottom: 15px;
`;
